import _ from "../Trans";
import React, {useEffect, useState} from "react";
import ReactGA from "react-ga4";
import Config from "../Config";
import token from "../AuthToken";
import {toast} from "react-toastify";
import {Button, Card, Col, Container, Row} from "reactstrap";
import ToggleSwitch from "./ToggleSwitch";


const unableToUpdatePreferencesMessage = _("Unable to update preferences: ");
const preferencesUpdatedMessage = _('Preferences updated');
const unableToRetrievePreferencesMessage = _("Unable to retrieve preferences");
const passwordUpdatedMessage = _('Password updated');
const preferredLanguageMessage = _('Preferred language');
const receiveEmailsMessage = _('Receive emails');
const updateYourPreferencesTitle = _('Update your preferences');
const updatePasswordText = _('Update your password');

export default function MyAccount() {
    const [receiveNewsletter, setReceiveNewsletter] = useState(true);
    const [name, setName] = useState('');
    const [lastName, setLastName] = useState('');
    const [lang, setLang] = useState('es');
    const [userId, setUserId] = useState(3);

    useEffect(() => {
        ReactGA.initialize(Config.GA_CODE);
        ReactGA.send({hitType: "pageview", page: "/my-account/", title: updateYourPreferencesTitle});
    }, []);  // eslint-disable-line

    const onNewsletterChange = (checked) => {
        setReceiveNewsletter(checked);
    }

    const onNameChange = e => setName(e.target.value)
    const onLastNameChange = e => setLastName(e.target.value)

    const getUserPreferences = function(e) {
        fetch(Config.fetchUserUrl, {
            headers: {
                Authorization: 'Token ' + token,
                'Content-Type': 'application/json'
            }
        })
        .then((e) => {
            if (e.status < 300) {
                return e.json();
            }
            return Promise.reject(e)
        })
            .then(data => {
                setUserId(data.user_id)
                setName(data.name);
                setLastName(data.last_name);
                setLang(data.language);
                setReceiveNewsletter(data.opt_in)
                return true;
            })
        .catch((e) => {
            if(e.status === 401) {
                window.location.href = Config.logoutPage;
            }
            toast.error(unableToRetrievePreferencesMessage, Config.toastConfig)
        })
    }

    useEffect(() => {
        getUserPreferences()
    }, []);  // eslint-disable-line

    const updateUserData = function (e) {
        e.preventDefault();
        fetch(Config.fetchUserUrl, {
            headers: {
                Authorization: 'Token ' + token,
                'Content-Type': 'application/json'
            },
            method: "PUT",
            body: JSON.stringify({
                'name': e.target[0].value,
                'last_name': e.target[1].value,
                'language': lang,
                'opt_in': receiveNewsletter
            })
        })
        .then((e) => {
            if (e.status < 300) {
                toast.success(preferencesUpdatedMessage, Config.toastConfig);
                return true;
            }
            return Promise.reject(e)
        })
        .catch((e) => {
            if(e.status === 401) {
                window.location.href = Config.logoutPage;
            }
            return new Promise((resolve, reject) => resolve(e.json()))
                .then((e) =>{
                    let errors = '';
                    for (const [key, value] of Object.entries(e)) {
                        let translation = _(key)
                        errors += translation+": "+value+" ";
                    }
                    toast.error(unableToUpdatePreferencesMessage+errors, Config.toastConfig)
                }
            )
        });
    }

    const updatePassword = function (e) {
        e.preventDefault();

        let new_password = e.target[1].value, new_password2 = e.target[2].value;
        if(new_password === "") {
            toast.error(_('Cannot update to empty password'), Config.toastConfig)
            return;
        }
        if (new_password !== new_password2) {
            toast.error(_('Passwords do not match'), Config.toastConfig)
            return;
        }

        fetch(Config.updatePasswordUrl.replace("/0/", "/"+userId+"/"), {
            headers: {
                Authorization: 'Token ' + token,
                'Content-Type': 'application/json'
            },
            method: "PUT",
            body: JSON.stringify({
                'password': e.target[0].value,
                'new_password': new_password,
                'new_password2': new_password2
            })
        })
        .then((e) => {
            if (e.status < 300) {
                toast.success(passwordUpdatedMessage, Config.toastConfig);
                return true;
            }
            return Promise.reject(e)
        })
        .then(() => {
            e.target[0].value = '';
            e.target[1].value = '';
            e.target[2].value = ''
        })
        .catch((e) => {
            if(e.status === 401) {
                window.location.href = Config.logoutPage;
            }
            toast.error(_("Unable to update user password"), Config.toastConfig)
        })
    }

    return (
        <div>
        <Container className="mt-3">
            <Row>
                <Col xs={12} className="font-color">
                    <h2 className="h3">{updateYourPreferencesTitle}</h2>
                </Col>
            </Row>
            <form onSubmit={updateUserData}>
                <Card className="p-3 font-color form-background">
                    <Row className="text-left">
                        <Col className="col-lg-2 d-none d-lg-block"/>
                        <Col lg={8} md={8} sm={12} xs={12}>
                            <label htmlFor="name">{_('Name')}</label>
                            <input id="name" name="name" type="text" value={name} onChange={onNameChange} className="form-control" placeholder={_('Name')}/>
                        </Col>
                    </Row>
                    <Row className="text-left">
                        <Col className="col-lg-2 d-none d-lg-block mt-3"/>
                        <Col lg={8} md={8} sm={12} xs={12} className="mt-3">
                            <label htmlFor="last_name">{_('Last Name')}</label>
                            <input id="last_name" name="last_name" type="text" value={lastName} onChange={onLastNameChange} className="form-control" placeholder={_('Last Name')}/>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="col-lg-2 d-none d-lg-block"/>
                        <Col  lg={8} md={8} sm={12} xs={12} className="mt-3">
                            <label htmlFor="language">{preferredLanguageMessage}</label>
                            <select className="form-control" id="language" name="language" value={lang} onChange={e => setLang(e.target.value)}>
                                <option key="es" value="es">{_('Español')}</option>
                                <option key="ca" value="ca">{_('Català')}</option>
                                <option key="en" value="en">{_('English')}</option>
                            </select>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="col-lg-2 d-none d-lg-block"/>
                        <Col lg={8} md={8} sm={12} xs={12} className="mt-3">
                            <Row>
                                <Col lg={3} md={3} sm={6} xs={6} className="left float-left">
                                    {receiveEmailsMessage}
                                </Col>
                                <Col lg={9} md={9} sm={6} xs={6} className="d-flex justify-content-end">
                                    <ToggleSwitch
                                        id="receive_emails"
                                        name={receiveEmailsMessage}
                                        optionLabels={[_('Yes'), _('No')]}
                                        onChange={onNewsletterChange}
                                        checked={receiveNewsletter}
                                    />
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="col-lg-2 d-none d-lg-block"/>
                        <Col lg={8} md={8} sm={12} xs={12}>
                            <Button className="form-control btn-btn-secondary mt-3">{_('Submit')}</Button>
                        </Col>
                    </Row>
                </Card>
            </form>
        </Container>
        <Container>
            <Row>
                <Col xs={12} className="mt-3 font-color">
                    <h2 className="h3">{updatePasswordText}</h2>
                </Col>
            </Row>
            <Card className="p-3 font-color form-background">
                <form onSubmit={updatePassword}>
                    <Row className="text-left">
                        <Col className="col-lg-2 d-none d-lg-block"/>
                        <Col lg={8} md={8} sm={12} xs={12} className="mt-3">
                            <input type="password" className="form-control" placeholder={_('Current password')}/>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="col-lg-2 d-none d-lg-block"/>
                        <Col  lg={8} md={8} sm={12} xs={12} className="mt-3">
                            <input type="password" className="form-control" placeholder={_('New password')}/>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="col-lg-2 d-none d-lg-block"/>
                        <Col  lg={8} md={8} sm={12} xs={12} className="mt-3">
                            <input type="password" className="form-control" placeholder={_('Repeat new password')}/>
                        </Col>
                    </Row>

                    <Row>
                        <Col className="col-lg-2 d-none d-lg-block"/>
                        <Col lg={8} md={8} sm={12} xs={12}>
                            <Button type="submit" className="form-control btn-btn-secondary mt-4">{_('Submit')}</Button>
                        </Col>
                    </Row>
                </form>
            </Card>
        </Container>

        <div style={{'marginBottom': '150px'}}></div>
        </div>
    )
}